import BlockIcon from '@mui/icons-material/Block'
import { LicenseRow } from '@/views/Operators/Operator/Licenses/licenses.dge.table'

import { CheckboxMenuSelectedItem } from '../CheckboxMenuSelectedItem/CheckboxMenuSelectedItem'

interface CheckboxDeactivateSelectedStreamingOperatorLicenseItemProps<T extends LicenseRow> {
  onDeactivate: (rows: T[]) => Promise<void> | void
}

export function CheckboxDeactivateSelectedStreamingOperatorLicenseItem<T extends LicenseRow>({
  onDeactivate
}: CheckboxDeactivateSelectedStreamingOperatorLicenseItemProps<T>) {
  return (
    <CheckboxMenuSelectedItem
      onAction={onDeactivate}
      renderItem={(row) => `${row.propertyName} (${row.propertyId})`}
      successMessage={(rows) => `${rows.length} licenses deactivated successfully`}
      errorMessage={(rows) => `Failed to deactivate ${rows.length} licenses`}
      confirmationTitle="Deactivate Licenses"
      confirmationMessage="Are you sure you want to deactivate the following licenses? This action cannot be undone. Already deactivated licenses will not be affected by this change."
      actionLabel="Deactivate"
      icon={<BlockIcon />}
    />
  )
}
